export default __webpack_public_path__ + "static/media/digitalcard_person_membership-pass.8c9acf01.svg";